export default [{
  path: '/portal-documentos',
  name: 'portaldocumentos-inerno',
  component: () => import('@/app-modulo/documento/portal-documentos-interno/PortalDocumentosInterno.vue'),
  meta: {
    resource: 'portaldocumentosinterno',
    action: 'read',
    navActiveLink: 'portaldocumentos-inerno',
    pageTitle: 'Portal de Documentos',
    useButtonDashBoardCobranca: true,
  },
}]
